export default __webpack_public_path__ + "static/media/5 Natesa Jewellery.2aacc9ec.png";